import {
  useGetUserBloomsTaxonomyActivities,
  getGetUserBloomsTaxonomyActivitiesQueryKey,
  useGetTopBloomsTaxonomyActivities,
  getGetTopBloomsTaxonomyActivitiesQueryKey,
  useDeleteBloomsTaxonomyActivities,
  likeBloomsTaxonomyActivities,
  unlikeBloomsTaxonomyActivities,
} from "@packages/api/madlenAPI";

import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { BloomsTaxonomyActivitiesResponseDto } from "@packages/api/madlenAPI.schemas";
import { BloomTaxonomyCard } from "../../components/blooms-taxonomy-activity/BloomTaxonomyCard";

interface ExtendedTool extends BloomsTaxonomyActivitiesResponseDto {
  isEditable?: boolean;
}

const BloomsTaxonomyActivityDetailComponent = ({
  tool,
}: {
  tool: ExtendedTool;
}) => {
  return (
    <BloomTaxonomyCard
      bloomsTaxonomyActivity={tool}
      isEditable={tool.isEditable}
    />
  );
};

const BloomsTaxonomyActivityView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserBloomsTaxonomyActivities}
      useDeleteTool={useDeleteBloomsTaxonomyActivities}
      getGetToolsQueryKey={getGetUserBloomsTaxonomyActivitiesQueryKey}
      useGetTopTools={useGetTopBloomsTaxonomyActivities}
      likeTool={likeBloomsTaxonomyActivities}
      unlikeTool={unlikeBloomsTaxonomyActivities}
      getGetTopToolsQueryKey={getGetTopBloomsTaxonomyActivitiesQueryKey}
      toolType="bloomsTaxonomyActivity"
      toolPath="blooms-taxonomy-activities"
      DetailComponent={BloomsTaxonomyActivityDetailComponent}
      colors={{
        light: "from-[#F3C969] to-[#81C784]",
        dark: "dark:from-[#FFD54F] dark:to-[#66BB6A]",
        iconBg: "bg-[#FFF7E6] dark:bg-[#2E4223]/30",
        iconColor: "text-bloomsTaxonomy dark:text-bloomsTaxonomyDark",
        hover: "hover:bg-[#FFF7E6] dark:hover:bg-[#24331A]/15",
      }}
      toolColor="bloom"
      gradientColor="bloom"
    />
  );
};

export default BloomsTaxonomyActivityView;
